// pvduy 06/01/2021 thêm api lấy dữ liệu cho cấp tổ chức.
import BaseAPI from "./base/base-api";

class OrganizationUnitTypeAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Business";
  controllerName = "OrganizationUnitType";
}

export default new OrganizationUnitTypeAPI();
